import { LinkProps } from '@cmpsr/components';
import { Link as ReactRouterLink } from 'react-router-dom';

/**
 * This function is used to add the correct props to the link
 * It will add the `as` and `to` props if the link is internal
 * Otherwise, it will return the props as is using `href`
 * @param props
 * @returns
 */
export const handleExternalLink = (props: LinkProps) => {
  const isExternal = !props.href?.startsWith('http');
  return {
    ...props,
    ...(isExternal ? {} : { as: ReactRouterLink, to: props.href }),
  };
};
